'use client';

import Image from 'next/image';
import { useLightboxActions } from './LightboxContext';
import Button from '@commons/Button';
import { Dots } from '@icons';
import { usePaginator } from '@commons/Paginator/PaginatorContext';
import useDictionary from '@modules/Dictionary/useDictionary';

export default function LightBoxItem({ image, index = 0, isOptionsButton = false }) {
  const { openLightbox } = useLightboxActions();
  const { setIndex } = usePaginator();
  const { dictionary } = useDictionary();

  const openLightboxWithIndex = () => {
    openLightbox();
    setIndex(index);
  };

  return (
    <li className={`Lightbox__item ${isOptionsButton ? 'Lightbox__item--options' : ''}`}>
      {isOptionsButton ? (
        <Button
          className="Carousel__item-options"
          priority="tertiary"
          size="auto"
          type="button"
          aria-label={dictionary?.lightbox?.showAll || 'Vis alle bilder'}
          onClick={openLightboxWithIndex}
        >
          <Dots aria-hidden="true" />
        </Button>
      ) : (
        <button
          type="button"
          className="Lightbox__item-button"
          aria-label={image.alt ? undefined : `${dictionary?.lightbox?.openImage || 'Åpne bilde'} ${index + 1}`}
          onClick={openLightboxWithIndex}
        >
          <Image
            src={image.url}
            alt={image.alt || ''}
            width={150}
            height={150}
            sizes="75px"
            quality={75}
          />
        </button>
      )}
    </li>
  );
}
